import { FC, useEffect, useState } from "react";
import orderOptimizerTranslationsHelper from "../../../../../languages/order-optimizer-translations.helper";
import OrderOptimizerCargoDetailsHiddenDetailsCenterTablesTableComponent from "./center-tables/order-optimizer-cargo-details-hidden-details-center-tables.component";
import OrderOptimizerCargoDetailsHiddenDetailsSummaryFooterComponent from "./summary-footer/order-optimizer-cargo-details-hidden-details-summary-footer.component";
import OrderOptimizerCargoDetailsHiddenDetailsHeadingTablesOrderTableComponent from "./heading-tables/order/order-optimizer-cargo-details-hidden-details-heading-tables-order-table.component";
import OrderOptimizerCargoDetailsItem from "../common/types/order-optimizer-cargo-details-item";

type OrderOptimizerCargoDetailsHiddenDetailsProps = {
  optimizationId: string | undefined;
  detailsItem: OrderOptimizerCargoDetailsItem;
};

const OrderOptimizerCargoDetailsHiddenDetailsComponent: FC<
  OrderOptimizerCargoDetailsHiddenDetailsProps
> = (props) => {
  const translations =
    orderOptimizerTranslationsHelper.getCargoDetailsTranslations();

  const [isABA, setIsABA] = useState<boolean>(false);

  useEffect(() => {
    if (props.detailsItem.orders[0].billingModel === "ABA") {
      setIsABA(true);
    } else {
      setIsABA(false);
    }
  }, [props.detailsItem.orders[0].billingModel]);

  return (
    <>
      <div className="order_optimizer_cargo_details_hidden_details">
        <div className="order_optimizer_cargo_details_hidden_details__heading_section">
          <div className="order_optimizer_cargo_details_hidden_details_order">
            <div className="order_optimizer_cargo_details_hidden_details__heading_section__left">
              <h4 className="order_optimizer_cargo_details_hidden_details__heading_section__left__text">
                {translations.table.headingTables.headingOrdersLabel}
              </h4>
            </div>
            <div className="order_optimizer_cargo_details_hidden_details__heading_section__right">
              <OrderOptimizerCargoDetailsHiddenDetailsHeadingTablesOrderTableComponent />
            </div>
          </div>
        </div>
        <div className="order_optimizer_cargo_details_hidden_details__center_section">
          <OrderOptimizerCargoDetailsHiddenDetailsCenterTablesTableComponent
            orders={props.detailsItem.orders}
            ordersSteps={props.detailsItem.steps.orders}
            lastPoint={props.detailsItem.steps.lastPoint}
          />
        </div>
        <div className="order_optimizer_cargo_details_hidden_details__lower_section">
          <OrderOptimizerCargoDetailsHiddenDetailsSummaryFooterComponent
            detailsItem={props.detailsItem}
            isABA={isABA}
          />
        </div>
      </div>
    </>
  );
};

export default OrderOptimizerCargoDetailsHiddenDetailsComponent;
